import { Star, Brightness1 } from '@mui/icons-material'
import { styled } from '@mui/material'
import React from 'react'

const RelatorioADM = styled('p')(() => ({
  fontWeight: 'bolder'
}))

const Icons = {
  1: <Star color="warning" />,
  2: <Brightness1 color="error" />,
  3: <RelatorioADM>ADM</RelatorioADM>
}

export default Icons
